//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'WorkflowDetailBasic',
  model: {
    props: 'value',
    event: 'update',
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      businessTypeList: 'workflow/getBusinessTypeList',
      businessModuleList: 'workflow/getBusinessModuleList',
      appList: 'workflow/getAppList',
    }),
    generateBusinessTypeList() {
      return [
        ...this.businessTypeList,
        { label: '统一使用DCR业务类型变量', value: 'custom_variable' },
      ];
    },
  },
  created() {
    this.getAppList();
  },
  methods: {
    ...mapActions({
      getAppList: 'workflow/requestAppList',
    }),
    // 用于保存时外部调用检查
    checkData(callback) {
      this.$refs.form.validate(callback);
    },
    updateData(e, key) {
      this.$emit('update', {
        ...this.value,
        [key]: e,
      });
    },
  },
};
